import Workflow from "../models/ui/workflow";
import PicklistDetail from "../models/picklist-detail";
import PicklistInfo from "../models/picklist-info";

const isDevEnv = "developmen" === process.env.NODE_ENV;

const DEV_DEFAULT_VALUE = {
    title: "",
    backEnabled: true,
    helpEnabled: true,
    headerBackgroundColor: "#191919",
    onBackPressed: null,
    backOptions: {
        open: false,
        primaryButtonTitle: "Continue Picking",
        primaryButtonOnClick: () => {
        },
        secondaryButtonTitle: "End Picking & Exit",
        secondaryButtonOnClick: () => {
        }
    },
    helpOptions: {
        open: false,
        title: "Help Center",
        pageTitle: "Page title",
        list: [{
            title: "Help option 1",
            onClick: () => {
                console.log("help clicked");
            }
        }]
    },
    workflow: new Workflow(),
    picklist: PicklistDetail.getInstance(new PicklistInfo())
};

export const DEFAULT_VALUE = isDevEnv ? DEV_DEFAULT_VALUE : {
    title: "",
    backEnabled: true,
    helpEnabled: false,
    headerBackgroundColor: "#191919",
    onBackPressed: null,
    helpOptions: {
        open: false,
        title: "",
        pageTitle: "",
        list: []
    },
    backOptions: {
        open: false,
        primaryButtonTitle: "Continue Picking",
        primaryButtonOnClick: () => {
        },
        secondaryButtonTitle: "End Picking & Exit",
        secondaryButtonOnClick: () => {
        }
    },
    workflow: null,
    picklist: null
};

export const AppContextActions = {
    UPDATE_PICKLIST_DETAILS: "UPDATE_PICKLIST_DETAILS",
    UPDATE_WORKFLOW: "UPDATE_WORKFLOW",
    SETUP_HEADER: "SETUP_HEADER",
    SETUP_HELP: "SETUP_HELP",
    OPEN_HELP: "OPEN_HELP",
    CLOSE_HELP: "CLOSE_HELP",
    SET_HEADER_COLOR: "SET_HEADER_COLOR",
    OPEN_BACK_DROP: "OPEN_BACK_DROP",
    CLOSE_BACK_DROP: "CLOSE_BACK_DROP"
}

export const AppContextReducer = (state, action) => {

    switch (action.type) {
        /**
         * Workflow, Picklist update
         */
        case AppContextActions.UPDATE_PICKLIST_DETAILS:
            return {...state, picklist: {...state.picklist, ...action.value}};
        case AppContextActions.UPDATE_WORKFLOW:
            return {...state, workflow: {...state.workflow, ...action.value}};

        /**
         * Header setup for back button and title, title doesn't change if not passed
         */
        case AppContextActions.SETUP_HEADER:
            return {...state, title: action.value.title || state.title, onBackPressed: action.value.onBackPressed};

        /**
         * Help options
         */
        case AppContextActions.SETUP_HELP:
            return {...state, helpEnabled: action.value.enabled, helpOptions: {...action.value.options, open: false}};
        case AppContextActions.OPEN_HELP:
            return {...state, helpOptions: {...state.helpOptions, open: true}};
        case AppContextActions.CLOSE_HELP:
            return {...state, helpOptions: {...state.helpOptions, open: false}};

        /**
         * Header background
         */
        case AppContextActions.SET_HEADER_COLOR:
            return {...state, headerBackgroundColor: action.value};

        /**
         * Backdrop options
         */
        case AppContextActions.OPEN_BACK_DROP:
            return {...state, backOptions: {...state.backOptions, ...action.value, open: true}};
        case AppContextActions.CLOSE_BACK_DROP:
            return {...state, backOptions: {...state.backOptions, open: false}};
        /**
         * returning the same state
         */
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/app-context-reducer.js